import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addCoupon } from "../../actions/couponAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import CouponForm from "./CouponForm";

const initialValues = {
  code: "",
  title: "",
  discountType: "fixed",
  discountValue: "",
  maxDiscountAmount: 0,
  minOrderAmount: 0,
  firstTimeOnly: true,
  usageLimit: 0,
  usageLimitPerUser: 1,
  startDate: "",
  endDate: "",
  status: true,
};

const AddCoupon = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const handleSubmit = async (values) => {
    setLoader(true);
    let res = await addCoupon(values);
    if (res?.data?.success) {
      toast.success(res.data.message);
      navigate("/coupon");
    }
    setLoader(false);
  };

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <CouponForm
          heading="Add Coupon"
          initialValues={initialValues}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default AddCoupon;
